import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=27a1ee5e&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a1ee5e",
  null
  
)

export default component.exports